import { Component, Input, OnInit } from '@angular/core';

import { Gift, GiftStatus } from '../../../../../../../../models/gift';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GiftService } from '../../../../../../../../services/gift/gift.service';
import { dateStringFromISO8601 } from '../../../../../../../../utils';


@Component({
  selector: 'app-change-gift-expiration-date-modal',
  templateUrl: './change-gift-expiration-date-modal.component.html',
  styleUrls: ['./change-gift-expiration-date-modal.component.css']
})
export class ChangeGiftExpirationDateModalComponent implements OnInit {
  @Input() gift: Gift;
  @Input() successCallback: () => undefined;

  public newExpirationDate = '';

  public loading = false;

  public errorMessage = '';
  public serverError: number = null;

  readonly dateStringFromISO8601 = dateStringFromISO8601;
  readonly GiftStatus = GiftStatus;

  constructor(
    public activeModal: NgbActiveModal,
    private giftService: GiftService,
  ) {}

  ngOnInit() {
    this.newExpirationDate = this.gift.expiration_date;
  }

  public onSubmit() {
    if (!this.hasValidInput()) { return; }

    this.errorMessage = '';

    this.giftService
      .changeGiftExpirationDate(
        this.gift.id,
        this.newExpirationDate
      )
      .then(() => {
        this.successCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = "You do not have permission to change this gift's expiration date.";
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public hasValidInput() {
    return this.newExpirationDate !== '';
  }
}
